import formatCurrency from "format-currency";
import invoiceEditTimeEntryModal from "../../../common/modals/InvoiceEditTimeEntryModal/invoiceEditTimeEntryModal.component";
import invoiceAddLineItemModal from "../../../common/modals/InvoiceAddLineItemModal/invoiceAddLineItemModal.component";
import confirmModal from "../../../common/modals/ConfirmModal/confirmModal.component";

class InvoiceDetailsController {

  constructor(toastr, $http, $rootScope, $stateParams, $uibModal, $state, AuthenticationService, InvoiceService) {
    "ngInject";

    let self = this;
    this.toastr = toastr;
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.$uibModal = $uibModal;
    this.$state = $state;
    this.auth = AuthenticationService;
    this.invoiceService = InvoiceService;
    this.availableLineItemsCount = 0;
    this.loadingAvailableLineItems = false;
    this.removingLineItemId = null;
    this.costPlusSummary = null;
    this.loadingCostPlusSummary = false;

    this.$http.get($rootScope.apiHost+"/api/admin/invoices/"+$stateParams.invoiceId, {withCredentials: true}).then(function (success) {
      self.invoice = success.data;
      self.companyLogoUri = $rootScope.apiHost+"/api/admin/companies/"+self.invoice.company.id+"/logo";
      self.invoiceSignatureUri = $rootScope.apiHost+"/api/users/me/signature";
      if (!self.isTravelInvoice()) {
        self.checkAvailableLineItems();
      }
      if (self.isPrimeCostPlusInvoice()) {
        self.loadCostPlusSummary();
      }
    });
  }

  isTravelInvoice() {
    return this.invoiceService.isTravelInvoice(this.invoice);
  }

  isPrimeCostPlusInvoice() {
    if (!this.invoice || this.isTravelInvoice()) {
      return false;
    }
    const contract = this.invoice.contract || {};
    const project = this.invoice.project || {};
    const isPrime = contract.contractClass === 'prime';
    const isCostBased = !!project.costBased
      || (typeof contract.contractType === 'string' && contract.contractType.indexOf('CP') === 0);
    return isPrime && isCostBased;
  }

  loadCostPlusSummary() {
    if (!this.invoice || !this.invoice.id) {
      return;
    }
    this.loadingCostPlusSummary = true;
    this.$http.get(this.$rootScope.apiHost + '/api/admin/invoices/' + this.invoice.id + '/cost-plus-summary', {
      withCredentials: true
    }).then((success) => {
      this.costPlusSummary = success.data;
    }).catch(() => {
      this.costPlusSummary = null;
      this.toastr.error('Unable to load cost-plus invoice summary.', 'Error');
    }).finally(() => {
      this.loadingCostPlusSummary = false;
    });
  }

  findLineItemById(lineItemId) {
    if (!this.invoice || !this.invoice.invoiceLineItems) {
      return null;
    }
    return this.invoice.invoiceLineItems.find((item) => item.id === lineItemId) || null;
  }

  editCostPlusLineItemHours(lineItemId) {
    const lineItem = this.findLineItemById(lineItemId);
    if (lineItem) {
      this.editTimeEntries(lineItem);
    }
  }

  removeCostPlusLineItem(lineItemId) {
    const lineItem = this.findLineItemById(lineItemId);
    if (lineItem) {
      this.removeLineItem(lineItem);
    }
  }

  getDisplayInvoiceNumber() {
    return this.invoiceService.formatInvoiceNumber(this.invoice);
  }

  getInvoiceTypeLabel() {
    return this.invoiceService.getInvoiceTypeLabel(this.invoice);
  }

  getTravelCurrentCost(lineItem) {
    if (!lineItem) {
      return 0;
    }
    if (lineItem.currentDollars != null && lineItem.currentDollars > 0) {
      return lineItem.currentDollars;
    }
    return lineItem.amount || 0;
  }

  openTravelBackupModal(lineItem) {
    const apiHost = this.$rootScope.apiHost;
    const category = lineItem.category || 'Expense Category';
    const expenses = lineItem.expenses || [];

    this.$uibModal.open({
      template: `
        <div class="inmodal">
          <div class="modal-header">
            <h4 class="modal-title">Current Cost — {{$ctrl.category}}</h4>
          </div>
          <div class="modal-body">
            <p class="text-muted" ng-if="!$ctrl.expenses.length">No supporting expenses were linked to this line.</p>
            <div ng-repeat="expense in $ctrl.expenses" class="m-b-md" style="border-bottom: 1px solid #eee; padding-bottom: 12px;">
              <div><strong>{{expense.type || $ctrl.category}}</strong> — {{expense.description || 'No description'}}</div>
              <div class="text-muted small">
                Amount: {{$ctrl.formatCurrency(expense.actualAmount)}}
                <span ng-if="expense.fromDate"> · {{expense.fromDate | date:'MMM dd, yyyy'}}</span>
              </div>
              <div class="m-t-xs" ng-if="expense.documentationLink">
                <a ng-href="{{expense.documentationLink}}" target="_blank" rel="noopener noreferrer">Documentation link</a>
              </div>
              <div class="m-t-xs" ng-if="expense.receipts && expense.receipts.length">
                <div ng-repeat="receipt in expense.receipts">
                  <a ng-href="{{$ctrl.receiptUrl(expense, receipt)}}" target="_blank" rel="noopener noreferrer">
                    {{receipt.documentName || receipt.receipt || 'Receipt'}}
                  </a>
                </div>
              </div>
              <div class="text-muted small m-t-xs" ng-if="(!expense.receipts || !expense.receipts.length) && !expense.documentationLink">
                No receipts attached.
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" ng-click="$ctrl.close()">Close</button>
          </div>
        </div>
      `,
      controller: ['$uibModalInstance', 'formatCurrency', function ($uibModalInstance, formatCurrencyFn) {
        this.category = category;
        this.expenses = expenses;
        this.formatCurrency = (value) => formatCurrencyFn(value || 0);
        this.receiptUrl = (expense, receipt) => {
          const reportId = expense.expenseReportId;
          const receiptKey = receipt.receipt;
          return `${apiHost}/api/expense-reports/${reportId}/expenses/${expense.id}/receipts/${receiptKey}`;
        };
        this.close = () => $uibModalInstance.dismiss('cancel');
      }],
      controllerAs: '$ctrl',
      resolve: {
        formatCurrency: () => formatCurrency
      }
    });
  }

  // Alias used by travel create-style Current Cost links
  openCategoryCostModal(lineItem) {
    this.openTravelBackupModal(lineItem);
  }

  getTotalHoursWorked() {
    let total = 0;
    if(this.invoice) {
      this.invoice.invoiceLineItems.forEach((li) => {
        total += this.getHoursWorkedForCurrentPeriod(li);
      });
    }

    return total;
  }

  getTotalCurrentDollars() {
    let total = 0;
    if(this.invoice && this.invoice.invoiceLineItems) {
      this.invoice.invoiceLineItems.forEach((li) => {
        if (this.isTravelInvoice()) {
          total += this.getTravelCurrentCost(li);
        } else {
          total += this.getAmountForCurrentPeriod(li);
        }
      });
    }

    return total;
  }

  getTotalCumulativeHoursWorked() {
    let total = 0;
    if(this.invoice) {
      this.invoice.invoiceLineItems.forEach((li) => {
        total += li.cumulativeHoursWorked;
      });
    }

    return total;
  }

  getTotalCumulativeDollars() {
    let total = 0;
    if(this.invoice) {
      this.invoice.invoiceLineItems.forEach((li) => {
        total += li.cumulativeDollars;
      });
    }

    return total;
  }

  getTotalDollars() {
    let total = 0;
    if(this.invoice) {
      this.invoice.invoiceLineItems.forEach((li) => {
        total += li.currentDollars
      });
    }

    return total;
  }

  getCumulativesForInvoicePeriodEnd() {

  }


  currency(value) {
    return formatCurrency(value);
  }

  canManageInvoices() {
    return this.auth.hasPermission('PERM_MANAGE_INVOICES');
  }

  getHoursWorkedForCurrentPeriod(lineItem){
    let hours = 0;
    if (lineItem.timeEntries) {
      lineItem.timeEntries.forEach((entry) => {
        hours += entry.hours;
      });
    }
    return hours;
  }

  getAmountForCurrentPeriod(lineItem){
    let amount = 0;
    if (lineItem.timeEntries) {
      lineItem.timeEntries.forEach((entry) => {
        amount += (entry.hours * lineItem.chargeCode.popRate.rate);
      });
    }
    return amount;
  }

  fetchAvailableLineItems() {
    return this.invoiceService.getAvailableLineItems(this.invoice.id)
      .then((response) => response.data || [])
      .catch((failure) => {
        if (failure.status === 404) {
          this.toastr.error('Invoice not found.', 'Error');
        } else if (failure.status === 400) {
          const message = (failure.data && failure.data.message)
            ? failure.data.message
            : 'Unable to load available line items.';
          this.toastr.error(message, 'Error');
        } else {
          this.toastr.error('Unable to load available line items.', 'Error');
        }

        return Promise.reject(failure);
      });
  }

  checkAvailableLineItems() {
    if (!this.canManageInvoices() || !this.invoice) {
      this.availableLineItemsCount = 0;
      return;
    }

    this.loadingAvailableLineItems = true;

    this.invoiceService.getAvailableLineItems(this.invoice.id)
      .then((response) => {
        this.availableLineItemsCount = (response.data || []).length;
      })
      .catch(() => {
        this.availableLineItemsCount = 0;
      })
      .finally(() => {
        this.loadingAvailableLineItems = false;
      });
  }

  hasAvailableLineItemsToAdd() {
    return this.availableLineItemsCount > 0;
  }

  getAvailableLineItemsMessage() {
    const count = this.availableLineItemsCount;

    if (count === 1) {
      return '1 funding line item from this project can be added to the invoice.';
    }

    return `${count} funding line items from this project can be added to the invoice.`;
  }

  openAddLineItemModal() {
    if (!this.canManageInvoices()) {
      return;
    }

    this.fetchAvailableLineItems().then((availableLineItems) => {
      const modalInstance = this.$uibModal.open(invoiceAddLineItemModal);
      modalInstance.invoice = this.invoice;
      modalInstance.availableLineItems = availableLineItems;

      modalInstance.success = () => {
        this.invoice = modalInstance.invoice;
        modalInstance.dismiss();
        this.checkAvailableLineItems();
        if (this.isPrimeCostPlusInvoice()) {
          this.loadCostPlusSummary();
        }
        this.toastr.success('Line items added to the invoice. Click hours in a row to assign time entries.');
      };

      modalInstance.cancel = () => {
        modalInstance.dismiss();
      };
    }).catch(() => {
      this.toastr.error('Unable to load available line items.', 'Error');
    });
  }

  removeLineItem(lineItem) {
    if (!this.canManageInvoices() || !lineItem || !this.invoice) {
      return;
    }
    if (this.removingLineItemId) {
      return;
    }

    const employeeName = lineItem.user
      ? ((lineItem.user.firstName || '') + ' ' + (lineItem.user.lastName || '')).trim()
      : '';
    const chargeCodeName = lineItem.chargeCode && lineItem.chargeCode.name
      ? lineItem.chargeCode.name
      : (lineItem.category || ('Line #' + lineItem.lineNumber));
    const subject = employeeName
      ? (employeeName + ' / ' + chargeCodeName)
      : chargeCodeName;

    const modalInstance = this.$uibModal.open(confirmModal);
    modalInstance.title = 'Remove Line Item';
    modalInstance.subject = subject;
    modalInstance.message = 'Remove this line item from the invoice? Any linked time entries will be uninvoiced and can be billed on a future invoice.';

    modalInstance.yes = () => {
      this.removingLineItemId = lineItem.id;
      this.invoiceService.removeLineItem(this.invoice.id, lineItem.id).then((success) => {
        this.invoice = success.data;
        modalInstance.dismiss();
        this.checkAvailableLineItems();
        if (this.isPrimeCostPlusInvoice()) {
          this.loadCostPlusSummary();
        }
        this.toastr.success('Line item removed. Linked time entries are now uninvoiced.', 'Success');
      }, (error) => {
        const message = (error.data && (error.data.message || error.data.error))
          || 'Could not remove the line item.';
        this.toastr.error(message, 'Error');
      }).finally(() => {
        this.removingLineItemId = null;
      });
    };

    modalInstance.no = () => {
      modalInstance.dismiss();
    };
  }

  exportPdf() {
    let url = this.$rootScope.apiHost+"/api/admin/invoices/"+this.invoice.id+"/export/pdf";
    window.open(url);
  }

  exportNewPdf() {
    let url = this.$rootScope.apiHost+"/api/admin/invoices/"+this.invoice.id+"/export/newinvoice";
    window.open(url);
  }

  exportExcel() {
    let url = this.$rootScope.apiHost+"/api/admin/invoices/"+this.invoice.id+"/export/xls";
    window.open(url);
  }


  editTimeEntries(lineItem) {
    let self = this;

    if(!this.canManageInvoices()){
      return;
    }

    //get all timeentries for employee during this invoice period
    this.$http.get(this.$rootScope.apiHost+"/api/admin/invoices/"+this.invoice.id+"/lineitems/"+lineItem.id+"/timeentries", {withCredentials: true}).then(function (success) {
      let modalInstance = self.$uibModal.open(invoiceEditTimeEntryModal);
      modalInstance.invoice = self.invoice;
      modalInstance.userId = lineItem.user.id;
      modalInstance.chargeCodeId = lineItem.chargeCode.id;
      modalInstance.employee = lineItem.user.firstName + " " + lineItem.user.lastName;
      modalInstance.chargeCode = lineItem.chargeCode.name;
      modalInstance.lineItem = lineItem;
      modalInstance.timeEntries = success.data;
      modalInstance.apiHost = self.$rootScope.apiHost;
      modalInstance.success = function () {
        self.invoice = modalInstance.invoice;
        modalInstance.dismiss();
        if (self.isPrimeCostPlusInvoice()) {
          self.loadCostPlusSummary();
        }
      };

      modalInstance.cancel = function () {
        modalInstance.dismiss();
      };
    });
  }

  deleteInvoice() {
    let self = this;
    this.$http.delete(this.$rootScope.apiHost+"/api/admin/invoices/"+this.invoice.id, {withCredentials: true}).then(function (success) {
        self.$state.go("admin.invoices");
    });
  }


  updateInvoiceDetails(parameter, value) {
    let obj = {};
    let payloadValue = value;

    if (parameter === 'date' || parameter === 'invoiceDate') {
      parameter = 'date';
      if (Object.prototype.toString.call(value) === '[object Date]' && !isNaN(value.getTime())) {
        const year = value.getFullYear();
        const month = ('0' + (value.getMonth() + 1)).slice(-2);
        const day = ('0' + value.getDate()).slice(-2);
        payloadValue = year + '-' + month + '-' + day + 'T00:00:00.000Z';
      }
    }

    obj[parameter] = payloadValue;

    this.$http.patch(this.$rootScope.apiHost+"/api/admin/invoices/"+this.invoice.id, obj, {withCredentials: true}).then(success => {
      this.invoice = success.data;
      this.toastr.success('The Invoice has been updated.');
    }, failure => {
      this.toastr.error('Could not update '+parameter, 'ERROR');
    });
  }

}

export default InvoiceDetailsController;



// WEBPACK FOOTER //
// ./client/pages/admin/invoice-details/invoice-details.controller.js